import { render, staticRenderFns } from "./dealer.vue?vue&type=template&id=9c6397c4&scoped=true"
import script from "./dealer.vue?vue&type=script&lang=js"
export * from "./dealer.vue?vue&type=script&lang=js"
import style0 from "./dealer.vue?vue&type=style&index=0&id=9c6397c4&lang=scss&scoped=true"
import style1 from "./dealer.vue?vue&type=style&index=1&id=9c6397c4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6397c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c6397c4')) {
      api.createRecord('9c6397c4', component.options)
    } else {
      api.reload('9c6397c4', component.options)
    }
    module.hot.accept("./dealer.vue?vue&type=template&id=9c6397c4&scoped=true", function () {
      api.rerender('9c6397c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/dealer.vue"
export default component.exports